import { Transition } from '@headlessui/react'
import { useTranslation } from 'react-i18next'
import { useId } from 'react'
import { inputClasses, labelClasses } from 'components/ui/inputClasses'

export type TextAreaProps = {
  value: string
  setValue: (value: string) => void
  label: string
  error?: string
}

export const TextArea = ({ value, setValue, label, error }: TextAreaProps) => {
  const { t } = useTranslation()
  const id = useId()
  const errorId = `${id}-error`
  return (
    <div className={'tw-flex tw-flex-col'}>
      <label htmlFor={id} className={labelClasses}>
        {label}
      </label>
      <textarea
        id={id}
        placeholder={label}
        aria-invalid={!!error}
        aria-describedby={error ? errorId : undefined}
        className={inputClasses(!!error, 'tw-min-h-[7rem] tw-resize-none tw-py-2.5')}
        value={value}
        onChange={(e) => setValue(e.target.value)}
      />
      <Transition
        show={!!error}
        enter="tw-transition-opacity tw-duration-300"
        enterFrom="tw-opacity-0"
        enterTo="tw-opacity-100"
        leave="tw-transition-opacity tw-duration-300"
        leaveFrom="tw-opacity-100"
        leaveTo="tw-opacity-0"
        className={'tw-mt-1 tw-text-xs tw-text-red-600'}
      >
        <span id={errorId} role="alert">
          {error ? t(error) : null}
        </span>
      </Transition>
    </div>
  )
}
